<template>
  <div
    :style="{
      '--divWidth--': divWidth,
      '--divHeight--': divHeight,
      position: IsBigDiv ? 'fixed' : 'static'
    }"
    style="width: var(--divWidth--);height: var(--divHeight--);top: 0;left: 0;z-index: 1000 !important;background-color: white;
    background-image: url(../../../static/banner/bigScreen.jpg);background-repeat:no-repeat;background-size: var(--divWidth--)  var(--divHeight--);overflow: hidden;"
  >
    <div
      @dblclick="BigScreen"
      style="margin: 1% auto 0; width: 50%;font-size: 1.875rem;text-align: center;font-weight: 800;
        color: white;"
    >
      移动赢销驾驶仓
    </div>
    <div
      style="width: 100%;margin-top: 1.5%;display: flex;justify-content: space-around;height: 26%;"
    >
      <div style="width: 25%;margin-left:1%;height:100%;">
        <dv-border-box-8
          ref="box2"
          style="width: 100%;height: 49.5%;display: flex;align-content: center;justify-content: center;"
          :key="2"
        >
          <div
            style="width: 100%;height: 100%;background-repeat: no-repeat;background-size: 100%;background-position-y:30%;display: flex;align-items: center;justify-content: space-around;flex-wrap: wrap;"
          >
            <div class="divTitle">
              今日走访单位数:
              <span class="spanText">{{
                fmoney(Statistics_data.visitorNumToday || 0)
              }}</span>
              <span class="spanTextOther">家</span>
            </div>
            <div class="divTitle">
              今日晒单年化金额:
              <span class="spanText">{{
                Statistics_data.userMoreProjectToday
                  ? fmoney(Statistics_data.userMoreProjectToday.userObyear || 0)
                  : 0
              }}</span>
              <span class="spanTextOther">元</span>
            </div>
            <div class="divTitle">
              今日签约单位数:
              <span class="spanText">{{
                Statistics_data.userMoreProjectToday
                  ? fmoney(
                      Statistics_data.userMoreProjectToday.userOrderNum || 0
                    )
                  : 0
              }}</span>
              <span class="spanTextOther">家</span>
            </div>
            <div class="divTitle">
              今日晒单合同总金额:
              <span class="spanText">{{
                Statistics_data.userMoreProjectToday
                  ? fmoney(Statistics_data.userMoreProjectToday.userKpi || 0)
                  : 0
              }}</span>
              <span class="spanTextOther">元</span>
            </div>
          </div>
        </dv-border-box-8>
        <dv-border-box-8
          ref="box3"
          style="width: 100%;height: 49.5%;margin-top:0.5%;display: flex;align-content: center;justify-content: center;"
          :key="3"
        >
          <div
            style="width: 100%;height: 100%;
                         background-repeat: no-repeat;background-size: 100%;background-position-y:30%;display: flex;align-items: center;justify-content: space-around;flex-wrap: wrap;"
          >
            <div class="divTitle">
              累计打卡量:
              <span class="spanText">{{
                fmoney(Statistics_data.visitorNumTotal || 0)
              }}</span>
              <span class="spanTextOther">家</span>
            </div>
            <div class="divTitle">
              累计晒单年化金额:
              <span class="spanText">{{
                Statistics_data.userMoreProjectTotal
                  ? fmoney(Statistics_data.userMoreProjectTotal.userObyear || 0)
                  : 0
              }}</span>
              <span class="spanTextOther">元</span>
            </div>
            <div class="divTitle">
              累计晒单合同总金额:
              <span class="spanText">{{
                Statistics_data.userMoreProjectTotal
                  ? fmoney(Statistics_data.userMoreProjectTotal.userKpi || 0)
                  : 0
              }}</span>
              <span class="spanTextOther">元</span>
            </div>
            <div class="divTitle">
              累计签约单位数:
              <span class="spanText">{{
                Statistics_data.userMoreProjectTotal
                  ? fmoney(
                      Statistics_data.userMoreProjectTotal.userOrderNum || 0
                    )
                  : 0
              }}</span>
              <span class="spanTextOther">家</span>
            </div>
          </div>
        </dv-border-box-8>
      </div>
      <dv-border-box-11
        ref="box8"
        class="box8"
        style="width: 50%;height: 100%;display: flex;"
        title="学和练"
        :key="8"
      >
        <div style="width: 100%;height: 100%;display: flex;">
          <div
            ref="eCharts5"
            style="width: 24%;height: 95%;margin-top: 1%;"
          ></div>
          <div
            ref="eCharts6"
            style="width: 24%;height: 95%;margin-top: 1%;"
          ></div>
          <div
            ref="eCharts7"
            style="width: 24%;height: 95%;margin-top: 1%;"
          ></div>
          <div
            ref="eCharts8"
            style="width: 24%;height: 95%;margin-top: 1%;"
          ></div>
        </div>
      </dv-border-box-11>
      <div style="width: 25%;height: 100%;margin-left: 1%;">
        <dv-border-box-10 ref="box4" style="width: 100%;height: 100%;" :key="4">
          <dv-scroll-board
            :config="config"
            ref="scrollBoard"
            style="width:95%;height:97%;margin: 0 2.5%;"
          />
        </dv-border-box-10>
      </div>
    </div>
    <div
      style="width: 100%;margin-top: 0.5%;display: flex;justify-content: space-around;height: 62%;"
    >
      <dv-border-box-11
        ref="box5"
        style="width: 33%;height: 100%;"
        title="打卡量"
        :key="5"
      >
        <div
          style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;"
        >
          <div
            style="width: 92%;height: 88%;background-color: rgba(38,81,207, 0.2);margin-top: 8%;border-radius: 3%;"
          >
            <div ref="eCharts1" style="width: 100%;height: 50%;"></div>
            <div ref="eCharts2" style="width: 100%;height: 50%;"></div>
          </div>
        </div>
      </dv-border-box-11>
      <dv-border-box-11
        ref="box6"
        style="width: 33%;height: 100%;"
        title="签约量"
        :key="6"
      >
        <div
          style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;"
        >
          <div
            style="width: 92%;height: 88%;background-color: rgba(38,81,207, 0.2);margin-top: 8%;border-radius: 3%;"
          >
            <div ref="eCharts3" style="width: 100%;height: 50%;"></div>
            <div ref="eCharts4" style="width: 100%;height: 50%;"></div>
          </div>
        </div>
      </dv-border-box-11>
      <dv-border-box-11
        ref="box7"
        style="width: 33%;height: 100%;"
        title="各战队数据对比"
        :key="7"
      >
        <div
          style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;"
        >
          <div
            style="width: 92%;height: 88%;background-color: rgba(38,81,207, 0.2);margin-top: 8%;border-radius: 3%;
                                display: flex;flex-wrap: wrap;align-items: center;justify-content: space-around;"
          >
            <div style="width: 50%;height: 50%;">
              <div
                style="width: 100%;text-align: center;font-weight: 600;color: white;font-size: 1.125rem;
                            line-height: 10%;margin-top: 10%;"
              >
                签约金额(元)
              </div>
              <dv-active-ring-chart
                ref="ringConfig"
                :config="ringConfig"
                style="width:100%;height:80%;margin-top: 5%;"
              />
            </div>
            <div style="width: 50%;height: 50%;">
              <div
                style="width: 100%;text-align: center;font-weight: 600;color: white;font-size: 1.125rem;
                            line-height: 10%;margin-top: 10%;"
              >
                签约人数
              </div>
              <dv-active-ring-chart
                ref="ringConfig2"
                :config="ringConfig2"
                style="width:100%;height:80%;margin-top: 5%;"
              />
            </div>
            <div style="width: 50%;height: 50%;">
              <div
                style="width: 100%;text-align: center;font-weight: 600;color: white;font-size: 1.125rem;
                            line-height: 10%;margin-top: 10%;"
              >
                打卡量
              </div>
              <dv-active-ring-chart
                ref="ringConfig3"
                :config="ringConfig3"
                style="width:100%;height:80%;margin-top: 5%;"
              />
            </div>
            <div style="width: 50%;height: 50%;">
              <div
                style="width: 100%;text-align: center;font-weight: 600;color: white;font-size: 1.125rem;
                            line-height: 10%;margin-top: 10%;"
              >
                参与打卡人数
              </div>
              <dv-active-ring-chart
                ref="ringConfig4"
                :config="ringConfig4"
                style="width:100%;height:80%;margin-top: 5%;"
              />
            </div>
          </div>
        </div>
      </dv-border-box-11>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "BigScreenDisplay",
  components: {},
  data() {
    let this_ = this;
    return {
      echartsStrValue5: [],
      echartsStr5: "",
      echartsStrValue6: [],
      echartsStr6: "",
      echartsStrValue7: [],
      echartsStr7: "",
      echartsStrValue8: [],
      echartsStr8: "",
      ringConfig: {
        radius: "75%",
        activeRadius: "80%",
        data: [],
        digitalFlopStyle: {
          fontSize: this_.nowSize(15)
        },
        showOriginValue: true
      },
      ringConfig2: {
        radius: "75%",
        activeRadius: "80%",
        data: [],
        digitalFlopStyle: {
          fontSize: this_.nowSize(15)
        },
        showOriginValue: true
      },
      ringConfig3: {
        radius: "75%",
        activeRadius: "80%",
        data: [],
        digitalFlopStyle: {
          fontSize: this_.nowSize(15)
        },
        showOriginValue: true
      },
      ringConfig4: {
        radius: "75%",
        activeRadius: "80%",
        data: [],
        digitalFlopStyle: {
          fontSize: this_.nowSize(15)
        },
        showOriginValue: true
      },

      echartsStr: "",
      echartsValue: {
        xdata: [],
        data: []
      },
      echartsStr2: "",
      echartsValue2: {
        xdata: [],
        data: []
      },
      echartsStr3: "",
      echartsValue3: {
        xdata: [],
        data: []
      },
      echartsStr4: "",
      echartsValue4: {
        xdata: [],
        data: []
      },

      color: [
        " #4992ff",
        " #dd79ff",
        " #fddd60",
        "  #ff6e76",
        " #58d9f9",
        " #05c091",
        "  #ff8a45",
        " #8d48e3"
      ],
      Statistics_data: {},
      theUserProject: null,
      divWidth: "100%",
      divHeight: "100%",
      IsBigDiv: true,
      config: {
        data: [],
        columnWidth: [100000],
        align: ["center"],
        oddRowBGC: "none",
        evenRowBGC: "rgba(38,81,207, 0.3)"
      }
    };
  },
  watch: {
    divWidth(n, v) {
      console.log(n);
      this.ringConfig = { ...this.ringConfig };
      this.ringConfig2 = { ...this.ringConfig2 };
      this.ringConfig3 = { ...this.ringConfig3 };
      this.ringConfig4 = { ...this.ringConfig4 };
      setTimeout(() => {
        this.$refs["scrollBoard"].updateRows(this.config.data);
        this.$refs.box2.initWH();
        this.$refs.box3.initWH();
        this.$refs.box4.initWH();
        this.$refs.box5.initWH();
        this.$refs.box6.initWH();
        this.$refs.box7.initWH();
        this.$refs.box8.initWH();
        this.echartsStr.resize();
        this.echartsStr2.resize();
        this.echartsStr3.resize();
        this.echartsStr4.resize();
        this.echartsStr5.resize();
        this.echartsStr6.resize();
        this.echartsStr7.resize();
        this.echartsStr8.resize();
      }, 300);
    }
  },
  async created() {
    this.theUserProject = A.local("$projectId");
    this.getLargeScreenStatistics({ projectId: this.theProjectId }).result(
      res => {
        this.Statistics_data = res.data.data;
        const config_data = [];
        res.data.data.resultList.forEach((item, index) => {
          const data = [`<div class="scrollboard" >${item}</div>`];
          config_data.push(data);
        });
        this.config.data = config_data;
        if (this.IsBigDiv) {
          this.divHeight = "100vh";
          this.divWidth = "100vw";
        } else {
          this.divHeight = "100%";
          this.divWidth = "100%";
        }
      }
    );
    this.getEchartsValue();
    var timer = setInterval(() => {
      setTimeout(() => {
        ///调取接口
        this.getLargeScreenStatistics({ projectId: this.theProjectId }).result(
          res => {
            this.Statistics_data = res.data.data;
            const config_data = [];
            res.data.data.resultList.forEach((item, index) => {
              const data = [`<div class="scrollboard" >${item}</div>`];
              config_data.push(data);
            });
            this.config.data = config_data;
            if (this.IsBigDiv) {
              this.divHeight = "100vh";
              this.divWidth = "100vw";
            } else {
              this.divHeight = "100%";
              this.divWidth = "100%";
            }
          }
        );
        this.getEchartsValue();
      }, 0);
    }, 5 * 60000);
  },
  mounted() {
    setTimeout(() => {
      this.$refs["scrollBoard"].updateRows(this.config.data);
      this.$refs.box2.initWH();
      this.$refs.box3.initWH();
      this.$refs.box4.initWH();
      this.$refs.box5.initWH();
      this.$refs.box6.initWH();
      this.$refs.box7.initWH();
      this.$refs.box8.initWH();
    }, 100);
    const _this = this;
    window.addEventListener("resize", function() {
      console.log("改变了");
      _this.echartsStr.resize();
      _this.echartsStr2.resize();
      _this.echartsStr3.resize();
      _this.echartsStr4.resize();
      this.echartsStr5.resize();
        this.echartsStr6.resize();
        this.echartsStr7.resize();
        this.echartsStr8.resize();
      setTimeout(() => {
        _this.$refs["scrollBoard"].updateRows(_this.config.data);
        _this.$refs.box2.initWH();
        _this.$refs.box3.initWH();
        _this.$refs.box4.initWH();
        _this.$refs.box5.initWH();
        _this.$refs.box6.initWH();
        _this.$refs.box7.initWH();
        this.$refs.box8.initWH();
      }, 100);
    });
  },

  methods: {
    // 图标配置项
    DrawEcharts() {
      var that = this;
      this.echartsStr = this.$echarts.init(this.$refs.eCharts1);
      this.echartsStr.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        radius: "80%",
        // backgroundColor: '#100C2A',
        title: {
          text:
            this.echartsValue.xdata[0] +
            "-" +
            this.echartsValue.xdata[this.echartsValue.xdata.length - 1],
          textStyle: {
            fontSize: this.nowSize(15),
            color: "white"
          },

          left: "3%",
          top: "5%"
        }, //标题位置
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "3%",
          top: "2%",
          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "60%"
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.echartsValue.xdata,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#c3dbff", //更改坐标轴文字颜色
                fontSize: this.nowSize(14) //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: "white"
              }
            },
            splitLine: {
              //网格线
              show: true, //是否显示
              lineStyle: {
                //网格线样式
                color: "#303133", //网格线颜色
                width: 1, //网格线的加粗程度
                type: "dashed" //网格线类型
              }
            }
          }
        ],
        series: this.echartsValue.data
      });
      this.echartsStr2 = this.$echarts.init(this.$refs.eCharts2);
      this.echartsStr2.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        radius: "70%",
        // backgroundColor: '#100C2A',
        title: {
          text:
            this.echartsValue2.xdata2[0].dateStart.slice(5) +
            "-" +
            this.echartsValue2.xdata2[
              this.echartsValue2.xdata.length - 1
            ].dateEnd.slice(5),
          textStyle: {
            fontSize: this.nowSize(15),
            color: "white"
          },

          left: "3%",
          top: "1%"
        }, //标题位置
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "cross"
          }
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "3%",
          top: "-1%",
          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "60%"
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "10%",

          height: "75%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.echartsValue2.xdata,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#c3dbff", //更改坐标轴文字颜色
                fontSize: this.nowSize(14) //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: "white"
              }
            },
            splitLine: {
              //网格线
              show: true, //是否显示
              lineStyle: {
                //网格线样式
                color: "#303133", //网格线颜色
                width: 1, //网格线的加粗程度
                type: "dashed" //网格线类型
              }
            }
          }
        ],
        series: this.echartsValue2.data
      });
      this.echartsStr3 = this.$echarts.init(this.$refs.eCharts3);
      this.echartsStr3.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        radius: "80%",
        // backgroundColor: '#100C2A',
        title: {
          text:
            this.echartsValue3.xdata[0] +
            "-" +
            this.echartsValue3.xdata[this.echartsValue3.xdata.length - 1],
          textStyle: {
            fontSize: this.nowSize(15),
            color: "white"
          },

          left: "3%",
          top: "5%"
        }, //标题位置
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "3%",
          top: "2%",
          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "60%"
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.echartsValue3.xdata,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#c3dbff", //更改坐标轴文字颜色
                fontSize: this.nowSize(14) //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: "white"
              },
              formatter: function(value, index) {
                return that.fmoney(value);
              }
            },
            splitLine: {
              //网格线
              show: true, //是否显示
              lineStyle: {
                //网格线样式
                color: "#303133", //网格线颜色
                width: 1, //网格线的加粗程度
                type: "dashed" //网格线类型
              }
            }
          }
        ],
        series: this.echartsValue3.data
      });
      this.echartsStr4 = this.$echarts.init(this.$refs.eCharts4);
      this.echartsStr4.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        radius: "70%",
        // backgroundColor: '#100C2A',
        title: {
          text:
            this.echartsValue4.xdata2[0].dateStart.slice(5) +
            "-" +
            this.echartsValue4.xdata2[
              this.echartsValue4.xdata.length - 1
            ].dateEnd.slice(5),
          textStyle: {
            fontSize: this.nowSize(15),
            color: "white"
          },

          left: "3%",
          top: "1%"
        }, //标题位置
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "cross"
          }
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "3%",
          top: "-1%",
          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "60%"
        },
        grid: {
          left: "3%",
          right: "3%",
          bottom: "10%",

          height: "75%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.echartsValue4.xdata,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#c3dbff", //更改坐标轴文字颜色
                fontSize: this.nowSize(14) //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: "white"
              },
              formatter: function(value, index) {
                return that.fmoney(value);
              }
            },
            splitLine: {
              //网格线
              show: true, //是否显示
              lineStyle: {
                //网格线样式
                color: "#303133", //网格线颜色
                width: 1, //网格线的加粗程度
                type: "dashed" //网格线类型
              }
            }
          }
        ],
        series: this.echartsValue4.data
      });
      this.echartsStr5 = this.$echarts.init(this.$refs.eCharts5);
      this.echartsStr5.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        // backgroundColor: '#100C2A',
        title: {
          text: "学习时长",
          left: "35%",
          top: "45%",
          textStyle: {
            color: "white",
            fontSize: this.nowSize(14)
          }
        }, //标题位置

        tooltip: {
          trigger: "item"
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "1%",
          top: "80%",

          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "90%",
          tooltip: {
            show: false // 关闭图例的引导线
          }
        },
        series: [
          {
            name: "客户建档",
            type: "pie",
            radius: "58%",
            data: this.echartsStrValue5,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
      this.echartsStr6 = this.$echarts.init(this.$refs.eCharts6);
      this.echartsStr6.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        // backgroundColor: '#100C2A',
        title: {
          text: "学习次数",
          left: "35%",
          top: "45%",
          textStyle: {
            color: "white",
            fontSize: this.nowSize(14)
          }
        }, //标题位置

        tooltip: {
          trigger: "item"
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "1%",
          top: "80%",

          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "90%",
          tooltip: {
            show: false // 关闭图例的引导线
          }
        },
        series: [
          {
            name: "学习次数",
            type: "pie",
            radius: "58%",
            data: this.echartsStrValue6,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
      this.echartsStr7 = this.$echarts.init(this.$refs.eCharts7);
      this.echartsStr7.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        // backgroundColor: '#100C2A',
        title: {
          text: "训练次数",
          left: "35%",
          top: "45%",
          textStyle: {
            color: "white",
            fontSize: this.nowSize(14)
          }
        }, //标题位置

        tooltip: {
          trigger: "item"
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "1%",
          top: "80%",

          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "90%",
          tooltip: {
            show: false // 关闭图例的引导线
          }
        },
        series: [
          {
            name: "训练次数",
            type: "pie",
            radius: "58%",
            data: this.echartsStrValue7,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
      this.echartsStr8 = this.$echarts.init(this.$refs.eCharts8);
      this.echartsStr8.setOption({
        darkMode: " auto",
        colorBy: "series",
        color: this.color,
        // backgroundColor: '#100C2A',
        title: {
          text: "训练平均匹配度",
          left: "28%",
          top: "45%",
          textStyle: {
            color: "white",
            fontSize: this.nowSize(14)
          }
        }, //标题位置

        tooltip: {
          trigger: "item"
        }, //提示框组件 ---数据项图形触发
        legend: {
          type: "scroll",
          orient: "horizontal", //图标列表的布局朝向
          right: "1%",
          top: "80%",

          textStyle: {
            // 图例的公用文本样式。
            color: "white",
            fontSize: this.nowSize(12)
          },
          pageTextStyle: {
            color: "white",
            fontSize: this.nowSize(11)
          },
          pageIconColor: "white",
          width: "90%",
          tooltip: {
            show: false // 关闭图例的引导线
          }
        },
        series: [
          {
            name: "练-平均匹配度",
            type: "pie",
            radius: "58%",
            data: this.echartsStrValue8,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    },
    async getEchartsValue() {
      var date = new Date();
      var year = date.getFullYear();
      var that = this;
      console.log(year);
      this.echartsStrValue5 = [];
      this.echartsStrValue6 = [];
      this.echartsStrValue7 = [];
      this.echartsStrValue8 = [];
      await this.getLargeScreenStatisticsDt({
        projectId: this.theUserProject
      }).result(res => {
        const data = res.data.data;
        this.echartsValue.xdata = data.dayList;
        const allYAxis = [];
        const allYAxis2 = [];
        const allYAxis3 = [];
        const allYAxis4 = [];
        const rang_config = [];
        const rang_config2 = [];
        const rang_config3 = [];
        const rang_config4 = [];
        data.departmentList.forEach((element, index) => {
          const yAxis = {
            name: element.dtName,
            type: "line",
            id: element.dtId,
            stack: "Total",
            areaStyle: {},
            smooth: true,
            emphasis: {
              focus: "series"
            },
            data: []
          };
          const yAxis2 = {
            name: element.dtName,
            id: element.dtId,
            type: "bar",
            barGap: 1,
            emphasis: {
              focus: "series"
            },
            label: {
              // 柱图头部显示值
              show: true,
              position: "top",
              color: "white",
              fontSize: this.nowSize(13),
              formatter: params => {
                return params.value[params.encode.x[0]];
              }
            },
            data: []
          };
          const yAxis3 = {
            name: element.dtName,
            type: "line",
            id: element.dtId,
            stack: "Total",
            areaStyle: {},
            smooth: true,
            emphasis: {
              focus: "series"
            },
            data: []
          };
          const yAxis4 = {
            name: element.dtName,
            id: element.dtId,
            type: "bar",
            barGap: 1,
            emphasis: {
              focus: "series"
            },
            label: {
              // 柱图头部显示值
              show: true,
              position: "top",
              color: "white",
              fontSize: this.nowSize(13),
              formatter: params => {
                return params.value[params.encode.x[0]] != 0
                  ? that.fmoney(params.value)
                  : params.value[params.encode.x[0]];
              }
            },
            data: []
          };
          allYAxis.push(yAxis);
          allYAxis2.push(yAxis2);
          allYAxis3.push(yAxis3);
          allYAxis4.push(yAxis4);
          data.dayList.forEach((week, weekIndeex) => {
            data.largeScreenVisitorDayResult.forEach((item, id) => {
              if (
                element.dtId == item.dtId &&
                `${year}-${week}` == item.dataDate
              ) {
                allYAxis[index].data.push(item.visitorNum);
              }
            });
          });
          data.dataDateWeekList.forEach((week, weekIndeex) => {
            data.largeScreenVisitorWeekResult.forEach((item, id) => {
              if (element.dtId == item.dtId && week == item.dataDate) {
                allYAxis2[index].data.push(item.visitorNum);
              }
            });
          });
          data.dayList.forEach((week, weekIndeex) => {
            data.largeScreenOrderDayResult.forEach((item, id) => {
              if (
                element.dtId == item.dtId &&
                `${year}-${week}` == item.dataDate
              ) {
                allYAxis3[index].data.push(item.userKpi);
              }
            });
          });
          data.dataDateWeekList.forEach((week, weekIndeex) => {
            data.largeScreenOrderWeekResult.forEach((item, id) => {
              if (element.dtId == item.dtId && week == item.dataDate) {
                allYAxis4[index].data.push(item.userKpi);
              }
            });
          });
        });
        data.largeScreenOrderNumsResult.forEach((item, index) => {
          const s = { name: item.dtName, value: item.userKpi };
          const s2 = { name: item.dtName, value: item.userNum };
          rang_config.push(s);
          rang_config2.push(s2);
        });
        data.largeScreenVisitorNumsResult.forEach((item, index) => {
          const s = { name: item.dtName, value: item.visitorNum };
          const s2 = { name: item.dtName, value: item.userNum };
          rang_config3.push(s);
          rang_config4.push(s2);
        });
        this.echartsValue.data = allYAxis;
        this.echartsValue2.xdata = data.dataDateWeekListResultRank;
        this.echartsValue2.xdata2 = data.dateWeekRankList;
        this.echartsValue2.data = allYAxis2;
        this.echartsValue3.xdata = data.dayList;
        this.echartsValue3.data = allYAxis3;
        this.echartsValue4.xdata = data.dataDateWeekListResultRank;
        this.echartsValue4.xdata2 = data.dateWeekRankList;
        this.echartsValue4.data = allYAxis4;
        this.ringConfig.data = rang_config;
        this.ringConfig = { ...this.ringConfig };
        this.ringConfig2.data = rang_config2;
        this.ringConfig2 = { ...this.ringConfig2 };
        this.ringConfig3.data = rang_config3;
        this.ringConfig3 = { ...this.ringConfig3 };
        this.ringConfig4.data = rang_config4;
        this.ringConfig4 = { ...this.ringConfig4 };
        this.$nextTick(() => {
          console.log(this.$refs.ringConfig);
          this.DrawEcharts();
        });
      });
      await this.getLargeScreenStatisticsStudy().result(res => {
        res.data.data.caseRecommendRankDurationDt.forEach((item, index) => {
          this.echartsStrValue5.push({
            value: item.durationRank,
            name: item.dtName,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              show: false // 不显示文字
            }
          });
        });
        res.data.data.caseRecommendRankNumsDt.forEach((item, index) => {
          this.echartsStrValue6.push({
            value: item.numRank,
            name: item.dtName,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              show: false // 不显示文字
            }
          });
        });
      });
      await this.getLargeScreenStatisticsTrain().result(res => {
        res.data.data.microLectureRankMatchDt.forEach((item, index) => {
          this.echartsStrValue8.push({
            value: item.matchRank,
            name: item.dtName,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              show: false // 不显示文字
            }
          });
        });
        res.data.data.microLectureRankNumsDt.forEach((item, index) => {
          this.echartsStrValue7.push({
            value: item.numRank,
            name: item.dtName,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              show: false // 不显示文字
            }
          });
        });
      });
    },

    BigScreen() {
      this.IsBigDiv = !this.IsBigDiv;
      if (this.IsBigDiv) {
        this.divHeight = "100vh";
        this.divWidth = "100vw";
      } else {
        this.divHeight = "100%";
        this.divWidth = "100%";
      }
    },

    //  换算方法
    nowSize(val, initWidth = 1920) {
      //当前视口宽度
      let nowClientWidth = document.documentElement.clientWidth;

      return val * (nowClientWidth / initWidth);
    },

    fmoney(s, n = 2) {
      n = n > 0 && n <= 20 ? n : 2;
      s = parseFloat((s + "").replace(/[^\d.-]/g, "")).toFixed(n) + "";
      let m = Number(JSON.parse(s)); // 深拷贝数据并转换为number类型
      let num = "";
      let w = ""; // 单位
      let l = s
        .split(".")[0]
        .split("")
        .reverse();
      if (l.length >= 13) {
        num = (m / 1000000000000).toFixed(n);
        w = "万亿";
      } else if (l.length >= 9) {
        num = (m / 100000000).toFixed(n);
        w = "亿";
      } else if (l.length >= 5) {
        num = (m / 10000).toFixed(n);
        w = "万";
      } else {
        num = m.toFixed(n);
        w = "";
      }
      num = parseFloat((num + "").replace(/[^\d.-]/g, "")).toFixed(n) + "";
      let gg = num
        .split(".")[0]
        .split("")
        .reverse();
      let r = num.split(".")[1] === "00" ? "" : "." + num.split(".")[1];
      let t = "";
      if (gg[gg.length - 1] === "-") {
        let index = gg.findIndex(item => item === "-");
        gg.splice(index, 1);
        for (let i = 0; i < gg.length; i++) {
          t += gg[i] + ((i + 1) % 3 == 0 && i + 1 != gg.length ? "," : "");
        }
        t += "-";
      } else {
        for (let i = 0; i < gg.length; i++) {
          t += gg[i] + ((i + 1) % 3 == 0 && i + 1 != gg.length ? "," : "");
        }
      }
      return (
        t
          .split("")
          .reverse()
          .join("") +
        r +
        w
      );
    }
  }
};
</script>

<style scoped>
.flex /deep/ #Myrouterview {
  padding: 0 !important;
  max-height: none !important;
}

.divTitle {
  color: #d6d7dd;
  font-size: 0.9rem;
  margin-left: 0.3125rem;
  width: 45%;
}

.spanText {
  color: white;
  font-weight: 600;
  font-size: 1.35rem;
}

.spanTextOther {
  color: white;
  font-weight: 400;
  font-size: 0.9375rem;
}

.scrollboard {
  /* background-color: rgba(38,81,207, 0.6); */
  border-radius: 1.5%;
  width: 100%;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/data/BigScreenDisplay.vue